// extracted by mini-css-extract-plugin
export default {"dropdown":"style_dropdown__WwYWL","avatar":"style_avatar__gVg-A"};